import { styled, StyleSystemProps, BoxProps, Flex } from '@withjoy/joykit';
import { DrawerV2 } from '@withjoy/joykit/components/DrawerV2';

export const StyledCloseButton = styled(DrawerV2.CloseButton)<BoxProps>``;

const closeButtonStyles: StyleSystemProps = {
  zIndex: 2,
};

export const styles = {
  closeButton: closeButtonStyles,
};

export const MobileProductQuickAddContainerSkeleton = styled(Flex)<{ isMobile?: boolean }>`
  flex-direction: column;
  position: relative;
  align-items: center;
  min-height: 100%;
`;
